import React from 'react';

export default function Spinner({ size = 20 }: { size?: number }) {
  return (
    <span
      className="border-2 border-navy border-t-transparent rounded-full animate-spin inline-block"
      style={{ width: size, height: size }}
    />
  );
}

export function PageLoading() {
  return (
    <div className="flex-1 flex items-center justify-center py-24">
      <Spinner size={28} />
    </div>
  );
}
